import React from 'react';
import { Checkbox, Radio, Input /*, Menu*/ } from 'antd';
import intl from 'react-intl-universal';
import './measurement.scss';
import PreferencesDialog from '../Preferences.dialog';

const I18nKeys=[
  'unitTitle',
  'in',
  'cm',
  'mm',
  'pt',
  'pc',
  'labelTitle',
  'defaultLabel',
  'customLabel',
  'placeHolder',
  'markupTitle',
  'defaultLeader',
  'fromDocument',
]
export default class Measurement extends React.Component {
  constructor(props) {
    super(props);
    this.state = Object.assign({
      unit: 'inch',
      label: '',
      labelType: 'custom',
      defaultLeader: true,
      fromDocument: false,
      showGuides:false,
      showRulers:false,
    },JSON.parse(localStorage.getItem(PreferencesDialog.measuringKey())));
  }
  changeState = (type, e) => {
    const state = this.state;
    switch (type) {
      case 'label':
        const value = e.target.value;
        state.labelType = value;
        if (value == 'default') {
          state[type] = '';
        } else state[type] = this.elmInput.value;
        break;
      case 'defaultLeader':
      case 'fromDocument':
        state[type] = e.target.checked;
        break;
      default:
        state[type] = e.target.value;
        break;
    }
    this.setState(state);
    this.save(state);
  };
  changeLabel = (e) => {
    const state = this.state;
    state.label = e.target.value;
    this.setState(state);
    this.save(state);
  };
  render() {
    const { unit, label, labelType, defaultLeader, fromDocument } = this.state;
    const translations = I18nKeys.reduce((i18n, key) => {
      i18n[key] = intl.formatMessage({ id: 'Preferences.Content.measuring.' + key });
      return i18n;
    }, {});

    return (
      <>
        <div className="title">{translations.unitTitle}</div>
        <div className="unit board">
          <Radio.Group value={unit} onChange={(e) => this.changeState('unit', e)}>
            <Radio className="unitRadio" value="inch">
              {translations.in}
            </Radio>
            <Radio className="unitRadio" value="cm">
              {translations.cm}
            </Radio>
            <Radio className="unitRadio" value="mm">
              {translations.mm}
            </Radio>
            <Radio className="unitRadio" value="pt">
              {translations.pt}
            </Radio>
            <Radio className="unitRadio" value="pica">
              {translations.pc}
            </Radio>
          </Radio.Group>
        </div>
        <div className="title">{translations.labelTitle}</div>
        <div className="label board">
          <Radio.Group value={labelType} onChange={(e) => this.changeState('label', e)}>
            <div className="row">
              <Radio className="labelRadio" value="none">
                {translations.defaultLabel}
              </Radio>
            </div>
            <div className="row">
              <Radio className="labelRadio fv__MS-label-input" value="custom">
                {translations.customLabel}
                <Input
                  placeholder={translations.placeHolder}
                  disabled={'none' == labelType}
                  value={label}
                  onChange={this.changeLabel}
                  ref={(elem) => (this.elmInput = elem)}></Input>
              </Radio>
            </div>
          </Radio.Group>
        </div>
        <div className="title">{translations.markupTitle}</div>
        <div className="leader board">
          
            <Checkbox className="markupRadio" checked={defaultLeader} onChange={(e) => this.changeState('defaultLeader', e)}>
              {translations.defaultLeader}
            </Checkbox>
          
        </div>
        <div className="row">
          <Checkbox checked={fromDocument} onChange={(e) => this.changeState('fromDocument', e)}>
            {translations.fromDocument}
          </Checkbox>
        </div>
      </>
    );
  }

  save (state) {
    this.props.onChange(state);
  }
}
